/* eslint-disable max-len, max-params, sort-keys */
import EventsAPI from "../../../shared/modules/EventsAPI";
import React from "react";

export default class LoggedInHomePageHelper {
  static primaryCta (label, url, id, scenario, disabled) {
    return (
      <div className={`center mb32 ${scenario}`}>
        <a
          className="btn btn-primary centered fit"
          disabled={disabled}
          href={url}
          id={id}
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => EventsAPI.trackCustomerEvent("clicked_cta", `${id} from ${window.location.pathname}`)}
        >
          {label}
        </a>
      </div>
    );
  }

  static primaryAndSecondaryCta (button1, button2, scenario) {
    const [
      [
        label1,
        url1,
        id1
      ],
      [
        label2,
        url2,
        id2
      ]
    ] = [
      button1,
      button2
    ];
    return (
      <div className={`center mb32 primary-secondary-buttons ${scenario}`}>
        <a
          className="btn btn-primary sbs-btn"
          data-test="buy-from-my-set"
          href={url1}
          id={id1}
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => EventsAPI.trackCustomerEvent("clicked_cta", `${id1} from ${window.location.pathname}`)}
        >
          {label1}
        </a>

        <a
          className="btn btn-secondary sbs-btn"
          href={url2}
          id={id2}
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => EventsAPI.trackCustomerEvent("clicked_cta", `${id2} from ${window.location.pathname}`)}
        >
          {label2}
        </a>
      </div>
    );
  }
}
